import { ActionButton, FormInputRow } from '@emerald-works-nova/components'
import { useEvent, useEventsOnViewLoad } from '@emerald-works/react-event-bus-client'
import { Divider, Grid } from '@mui/material'
import React from 'react'
import { useForm } from 'react-hook-form'
import { useSelector } from 'react-redux'
import { BannerStatic } from '../../../../../components'
import { TenantEditSlice } from '../../../../../reducers'
import Header from '../../header'
import UploadInput from './upload-input'

const requiredKeys = ['s3Key']

const UserNameIdUpdate = ({ onClickCancel, onUploadStart }) => {
  const { pk: tenantId, region } = useSelector(TenantEditSlice.selectors.tenant)

  const form = useForm({
    mode: 'onChange',
    criteriaMode: 'all',
    defaultValues: { s3Key: '' }
  })

  const { handleSubmit, setValue, reset, watch } = form

  const [userNameIdMigrationUpdate] = useEvent([{
    eventName: 'userNameIdMigrationUpdate',
    onSuccess: () => BannerStatic.show({ label: 'User NameId migration saved' }),
    onError: () => BannerStatic.show({ label: 'User NameId migration error', isError: true })
  }])

  const onSubmit = data => {
    userNameIdMigrationUpdate.trigger({ ...data, tenantId, region })
  }

  const handleClickCancel = () => {
    reset()
    onClickCancel()
  }

  const handleFileAccept = ({ s3Key }) => setValue('s3Key', s3Key)

  useEventsOnViewLoad(() => {
    userNameIdMigrationUpdate.registerAdhocOnSuccessListener(onUploadStart)
  }, [userNameIdMigrationUpdate])

  const values = watch()
  const isLoading = userNameIdMigrationUpdate.isWorking
  const isValid = requiredKeys.every(key => !!values[key])

  return (
    <Grid container>
      <Header
        title='Update User NameIds'
        actions={
          <>
            <Grid item>
              <ActionButton
                variant='secondary'
                dataTest='user-nameid-update-cancel-button'
                onClick={handleClickCancel}
                disabled={isLoading}
              >
                Cancel
              </ActionButton>
            </Grid>
            <Grid item>
              <ActionButton
                variant='primary'
                onClick={handleSubmit(onSubmit)}
                disabled={!isValid}
                isWorking={isLoading}
                dataTest='update-upload-button'
              >
                Upload NameIds
              </ActionButton>
            </Grid>
          </>
        }
      />
      <Divider width='100%' />
      <Grid item xs={12}>
        <FormInputRow
          title='File Upload'
          description='Upload a CSV UTF-8 (Comma delimited) file that contains the headers: OldNameId, NewNameId.'
          smallFormTitles
          InputComponent={<UploadInput onAccept={handleFileAccept} />}
        />
      </Grid>
    </Grid>
  )
}

export default UserNameIdUpdate
